import React from 'react';
import { Link } from "react-router-dom";
//import {validatnews} from '../Utils/validate';
//import { gettoastsuccess,gettoastwarning } from '../Utils/Common';
//import API from '../Utils/Api';
//import loader from '../assests/loader.gif';

const Footer = () => {
	//const [inputsnews,setInputsnews] = useState({news_email:''});
	//const [errorsnews,setErrorsnews] = useState({});
	//const [loadingnews,setLoadingnews] = useState(false);
	
/* Start Value set */
/*const handleInputChangeNews = (event) => {
      event.persist();
      setInputsnews(inputsnews => ({...inputsnews, [event.target.name]: event.target.value})); 
}*/
/* Start Submit */
/*const handleSubmitNews = () => {
	const validationErrors = validatnews(inputsnews);
    const noErrors = Object.keys(validationErrors).length === 0;
	setErrorsnews({});
     setErrorsnews(validationErrors);
	 if(noErrors){
		setLoadingnews(true);
		 let formData = new FormData(); 
			formData.append('email', inputsnews.news_email);
			API.post('newsletter', formData)
                .then(response => {
                if(response.data.status === 0){
					gettoastwarning(response.data.message,'');
                    setLoadingnews(false); 
                }else{
					setLoadingnews(false); 
					setInputsnews({news_email:''});
				   gettoastsuccess(response.data.message,'');
                }                  
            }).catch(error => {
                 setLoadingnews(false);
				 gettoastwarning('Something went wrong. Please try again later.','');
			});
	 }
}*/
	
  return (
    <footer className="footer">
      {/* Main Heading */}
      <div className="row">
        <div className="col-md-12">
          <h2>
            Connecting singles <br /> through in-person events.
          </h2>
        </div>
      </div>

      <div className="line"></div>

      {/* App Store & Newsletter Section */}
      <div className="row mt-4 align-items-center ghumasom g-4">
        <div className="col-md-6 middle">
          <p>GET THE APP</p>
          <div className="d-flex gap-3">
            <Link to="https://apps.apple.com/us/app/your-friend-my-friend/id6748553590" className="store-link" target='_blank'>
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/appstore.svg'}
                alt="App Store"
                className="img-fluid store-image store-image-1"
              />
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/apphy-hover.svg'}
                alt="Event Promo Hover"
                className="img-fluid store-image store-image-2"
              />
            </Link>
            <Link to="https://play.google.com/store/apps/details?id=com.yourfriend.myfriend" className="store-link" target='_blank'>
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/playstore.svg'}
                alt="Google Play"
                className="img-fluid store-image store-image-1"
              />
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/googlehy-hover.svg'}
                alt="Event Promo Hover"
                className="img-fluid store-image store-image-2"
              />
            </Link>
          </div>
        </div>
        {/*<div className="col-md-6 d-flex flex-column align-items-end respo responser">
          <div className="middle-right">
            <p>Subscribe to our newsletter</p>
            <div className="d-flex">
              <div className="subscribe-box">
                <input
                  type="text"
				  name="news_email" value={inputsnews.news_email} 
                  placeholder="Your email address"
                  className="form-control bg-transparent border-0 text-light"
				  onChange={handleInputChangeNews}
                />
              </div>
              <button className="btn px-3 footer-control foo-arrow" type="button" onClick={handleSubmitNews}>
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/right-arrow.svg'}
                  alt="Google Play"
                  className="img-fluid"
                />
              </button>
			  
            </div>
			{errorsnews.news_email && (<p className="text-danger mt-2 text-inherit-news">{errorsnews.news_email}</p>)}
          </div>
        </div>*/}
      </div>

      <div className="lines"></div>

      {/* Footer Links */}
      <div className="row mt-4 align-items-center justify-content-between g-4">
        <div className="col-md-3 text-md-start">
          <div className="friend-tags">
            <Link to="/">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/header-logo.svg'}
              alt="Logo"
              className="img-fluid"
            />
            </Link>
          </div>
        </div>
        <div className="col-md-8">
          <ul className="footer-links list-unstyled d-flex justify-content-end align-items-center flex-wrap">
            <li>
              <Link to="/upcoming-events" className="text-decoration-none">
                Book tickets
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-decoration-none">
                Contact
              </Link>
            </li>
            <li>
              <Link to="https://apps.apple.com/us/app/your-friend-my-friend/id6748553590" className="text-decoration-none" target='_blank'>
                Get the app
              </Link>
            </li>
            <li>
              <Link to="/trust-safety" className="text-decoration-none">
                Trust & safety
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="text-decoration-none">
                Privacy policy
              </Link>
            </li>
            <li>
              <Link to="/terms-of-service" className="text-decoration-none">
                Terms of services
              </Link>
            </li>
            <li>
              <Link to="/blog" className="text-decoration-none">
                YFMF Field Notes
              </Link>
            </li>
            <li>
              <Link to="" className="text-decoration-none">
                Your Friend, My Friend Ltd.
              </Link>
            </li>
            <div className="d-flex">
            <li>
              <Link to="https://www.instagram.com/yourfriendmyfriend.ie" target="_blank">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/instagram.svg'}
                  alt="Instagram"
                  className="social-icon"
                />
              </Link>
            </li>
            <li>
              <Link to="https://www.tiktok.com/@yourfriendmyfriend.ie" target="_blank">
				<img
				  src={process.env.REACT_APP_BASE_URL + 'assests/images/tiktok.svg'}
				  alt="TikTok"
				  className="social-icon"
				/>
				</Link>
            </li>
            </div>
          </ul>
        </div>
      </div>
	  {/*loadingnews && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )*/} 
    </footer>
	
  );
};

export default Footer;
